export default {
  "anchor": "lrdwu",
  "link": "jDOio"
};